import classNames from 'classnames';
import styles from './HeaderCard.module.scss';
import { UI_Heading } from 'ui/components/1-atoms/Heading/Heading';
import { UI_Picture } from 'ui/components/1-atoms/Media/Picture/Picture';
import { UI_Container } from 'ui/components/4-habitats/Container/Container';
import { UI_LinkButton } from 'ui/components/1-atoms/Action/LinkButton/LinkButton';
import { UI_RichText } from 'ui/components/1-atoms/RichText/RichText';

export interface HeaderCardProps {
	className?: string;
	kicker?: string;
	teaser?: string;
	heading?: React.ReactNode;
	subeHeading?: string;
	image?: {
		url: string;
		focalPoint?: { left: number; top: number };
		extension?: string;
	};
	imageAltText?: string;
	link?: {
		url: string;
		target?: string;
		name?: string;
	};
	roundImage?: boolean;
	reducedSpacing?: boolean;
	smallImage?: boolean;
	player?: React.ReactNode;
}

export const UI_HeaderCard = ({
	className,
	teaser,
	heading,
	subeHeading,
	kicker,
	image,
	imageAltText,
	link,
	roundImage,
	reducedSpacing,
	smallImage,
	player,
}: HeaderCardProps) => (
	<UI_Container
		className={classNames(
			styles.HeaderCard,
			!image && !player && styles.HeaderCard___withoutMedia,
			reducedSpacing && styles.HeaderCard___reducedSpacing,
			smallImage && styles.HeaderCard___smallImage,
			roundImage && styles.HeaderCard___roundImage,
			className,
		)}
		width="Standard"
	>
		<div className={styles.HeaderCard_textWrapper}>
			{kicker && <div className={styles.HeaderCard_kicker}>{kicker}</div>}
			<div className={styles.HeaderCard_heading}>
				<UI_Heading headingLevel="h1" style={reducedSpacing ? 'xl' : 'xl50'}>
					{heading}
				</UI_Heading>
			</div>
			{subeHeading && (
				<UI_Heading headingLevel="h2" style="lg" className={styles.HeaderCard_subHeading}>
					{subeHeading}
				</UI_Heading>
			)}
			{teaser && <UI_RichText className={styles.HeaderCard_lead} style="large" content={teaser} />}
			{link?.url && (
				<UI_LinkButton className={styles.HeaderCard_link} url={link.url} target={link.target} style="cta">
					{link.name}
				</UI_LinkButton>
			)}
		</div>
		{(player || image) && (
			<div className={classNames(styles.HeaderCard_mediaWrapper, { [styles.HeaderCard_mediaWrapper___round]: roundImage })}>
				{player ? (
					<div className={styles.HeaderCard_video}>{player}</div>
				) : (
					image && (
						<UI_Picture
							focalPoint={{ left: image.focalPoint?.left, top: image.focalPoint?.top }}
							url={image.url}
							altText={imageAltText}
							className={classNames(styles.HeaderCard_image)}
							style={roundImage ? 'round' : null}
							imageCropping={smallImage ? 'contain' : 'cover'}
						/>
					)
				)}
			</div>
		)}
	</UI_Container>
);
